import { SectionHeading } from "./HotComics";

const features = [
  {
    icon: "ri-collage-line",
    title: "无删减下拉式阅读",
    desc: "画面与对白原汁原味呈现，手指轻滑即可连续下拉阅读，章节无缝衔接，沉浸感十足。",
  },
  {
    icon: "ri-lock-unlock-line",
    title: "免费看全集不设限",
    desc: "无需注册、无需付费，热门韩漫免费看全集，章节完整、收藏不迷路，随时开读。",
  },
  {
    icon: "ri-device-line",
    title: "多端适配畅读",
    desc: "手机、平板、电脑全面适配，横竖屏自由切换，高清画质在任何设备上都清晰流畅。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日定时追更",
    desc: "热门连载每日定时更新，加入收藏即可收到最新章节提醒，追更一步不落。",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      className="relative mx-auto px-4 md:px-8 py-14 md:py-20 overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-primary-700/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-16 w-80 h-80 rounded-full bg-accent-600/15 blur-3xl pointer-events-none" />

      <SectionHeading
        anchor="features"
        kicker="阅读体验 · EXPERIENCE"
        title="随时随地，畅享高清韩漫免费阅读"
        desc="从下拉阅读到多端同步，我们专注打磨每一个阅读细节，让追漫成为一件轻松又享受的事。"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 relative">
        {features.map((f, i) => (
          <div
            key={f.title}
            className="rounded-lg bg-background-900/70 border border-background-800/60 p-5 md:p-6 hover:border-primary-600/50 transition-colors duration-300"
          >
            <span
              className={`w-12 h-12 flex items-center justify-center rounded-lg ${
                i % 2 === 0 ? "bg-primary-600/20 text-primary-400" : "bg-accent-500/20 text-accent-400"
              }`}
            >
              <i className={`${f.icon} text-2xl`} />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-50">{f.title}</h3>
            <p className="mt-2 text-sm text-foreground-400 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}